// src/services/api/referencesApi.ts
import { createApiService } from './base';
import { Reference } from '../../types/content';

const referencesService = createApiService<Reference>('references');

export const fetchReferences = referencesService.getAll;
export const fetchReference = referencesService.getOne;
export const createReference = referencesService.create;
export const updateReference = referencesService.update;
export const deleteReference = referencesService.delete;
export const updateReferencesOrder = referencesService.updateOrder;
